import js_helper from "./html_bind_popup";
import event_bus from "../../main";

export default {
	getOsm() {
		return new L.TileLayer(
			"https://{s}.tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=1d3ac4bf7fd2476daabd4a11bdbdbfec",
			{
				minZoom: 9,
				maxZoom: 19,
				crs: L.CRS.EPSG3857
			}
		);
	},
	getSpeedLayer() {
		return new L.tileLayer.wms(
			"https://infomobility.tirana.al/ms/services/netstate/OBS_speed",
			{
				crs: L.CRS.EPSG4326,
				layers: "theLayer",
				format: "image/png",
				transparent: true,
				version: "1.1.1",
				attribution: ""
			}
		).setZIndex(999);
	},
	getTraficLayer() {
		return new L.tileLayer.wms(
			"https://infomobility.tirana.al/ms/services/netstate/OBS_flow",
			{
				crs: L.CRS.EPSG4326,
				layers: "theLayer",
				format: "image/png",
				transparent: true,
				version: "1.1.1",
				attribution: ""
			}
		).setZIndex(999);
	},
	getIcon(icon_url_used_in_map) {
		var icon_size = [35, 35];
		return L.icon({
			iconUrl: icon_url_used_in_map,
			iconRetinaUrl: icon_url_used_in_map,
			shadowUrl: "",
			iconSize: icon_size,
			shadowSize: icon_size,
			iconAnchor: [23, 23],
			shadowAnchor: [4, 62],
			popupAnchor: [-5, 0]
		});
	},
	getLineStrokeStyle(getMapData, from_where, index) {
		var prop =
			getMapData[index].properties != undefined
				? getMapData[index].properties
				: null;
		if (prop != null) {
			if (from_where == 1) {
				prop["stroke"] = "#1d1b89";
				prop["stroke-opacity"] = 0.8;
				prop["stroke-width"] = 4;
			}
			if (from_where == 5) {
				prop["stroke"] != undefined
				? prop["stroke"]
				: (prop["stroke"] = "#ec008c");
				prop["stroke-opacity"] != undefined
				? prop["stroke-opacity"]
				: (prop["stroke-opacity"] = 0.8);
				prop["stroke-width"] != undefined
				? prop["stroke-width"]
				: (prop["stroke-width"] = 4);
			}
			return {
				weight: prop["stroke"] != undefined ? prop["stroke-width"] : 4,
				color: prop["stroke-opacity"] != undefined ? prop.stroke : "#1d1b89",
				opacity:
				prop["stroke-width"] != undefined ? prop["stroke-opacity"] : 0.9,
				fillColor: prop["fill"] != undefined ? prop["fill"] : this.fillColor,
				fillOpacity:
				prop["fill-opacity"] != undefined ? prop["fill-opacity"] : 1
			};
		}
	},
	getMarker(
		feature,
		cordinates,
		extraClasses,
		icon_url_used_in_map,
		map_data,
		from_where
	) {
		return L.marker(cordinates, {
			icon: this.getIcon(icon_url_used_in_map)
		}).bindPopup(
			this.makePopupSwitchIntoDataThatCome(feature, 1, map_data, from_where),
			{
				className: extraClasses
			}
		);
		// .on("mouseover", this.markerEvent(from_where));
	},
	/**
	 * Switch coordinates to be Leaflet lat-lng compatible 
	 */
	getMarkerCoordinatesSwitch(coordinates){
		return [coordinates[1], coordinates[0]]
	},
	/**
	 * feature, are the feature for each point
	 * layer_or_marker is if the popup is for layer=2 or for marker=1
	 *
	 */
	makePopupSwitchIntoDataThatCome(
		feature,
		layer_or_marker = 1,
		map_data,
		from_where
	) {
		switch (from_where) {
		case 1:
			return js_helper.getParkingPoupup(feature, map_data);
		case 2:
			return js_helper.getBicyclePoupup(feature);
		case 3:
			return js_helper.getTransportType(feature, map_data);
		case 4:
			return js_helper.getTaxiPopup(
				feature,
				map_data.kategorite[feature.properties.kategoria - 1]
			);
		case 6:
			return js_helper.getTraficViewPopup(feature);
		case 7:
			return js_helper.getAdministativeUnitPopup(feature, layer_or_marker);
		case 8:
			return js_helper.getTurisemPopup(feature, map_data);
		case 10:
			return js_helper.getShkollatComunity(
				feature,
				this.getTypeOfCategory(feature, map_data).name
			);
		default:
			return "";
		}
	},
	getTypeOfCategory(feature, map_data) {
		return map_data.kategorite.filter(el => {
			return el.id == feature.properties.category_id;
		})[0];
	},
	refreshMap() {
		setTimeout(() => {
			window.dispatchEvent(new Event("resize"));
		}, 250);
	},
	goTurisemDetail(id, turisem_el) {
		localStorage.turisem_point_detail = id;
		event_bus.$router.push({
			name: "TurisemDetail",
			path: "/turisem/turisemdetail",
			params: { point_id: id, info_or_turisem: turisem_el }
		});
	}
};
